<template>
  <button
    :class="[
      isDisabled ? `${styles} disabled ${size}` : `${styles} ${size}`,
      { 'dark-mode': darkMode },
    ]"
    :style="styleObject"
    :disabled="isDisabled"
    :type="type"
  >
    <div
      v-if="hasLoader"
      class="spinner"
      :class="{ disabled: isDisabled }"
    ></div>

    <div
      v-else
      class="content"
      :class="!!iconLeft || !!iconRight ? 'no-icon' : ''"
    >
      <i v-if="!!iconLeft" :class="iconLeft" />

      {{ text }}

      <i v-if="!!iconRight" :class="iconRight" />
    </div>
  </button>
</template>

<script>
export default {
  name: 'ButtonComponent',

  props: {
    text: {
      type: String,
      default: 'text',
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    hasLoader: {
      type: Boolean,
      default: false,
    },

    iconLeft: {
      type: String,
      required: false,
    },

    iconRight: {
      type: String,
      required: false,
    },

    size: {
      type: String,
      default: '',
    },

    buttonTextColor: {
      type: String,
      default: '#FF9C00',
    },

    buttonHoverColor: {
      type: String,
      default: 'rgba(255, 156, 0, 0.1)',
    },

    styles: {
      type: String,
      default: 'primary',
    },

    type: {
      type: String,
      default: 'submit',
    },

    darkMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    styleObject: function () {
      return {
        color: this.buttonTextColor,
        '--color-hover': this.buttonHoverColor,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  min-height: 40px;
  max-height: 48px;
  border: none;
  border-radius: 6px;
  outline: none;
  cursor: pointer;
  transition: all 0.3s ease;

  justify-content: center;
  align-items: center;
  display: flex;

  &.primary {
    color: #fff !important;
    background: #ff8b00;

    &.disabled {
      background: #dadada;
    }

    &:not(.disabled):hover {
      background: #ff9c00;
    }
  }

  &.secondary {
    width: auto;
    background: transparent;

    &.disabled {
      background: transparent;
    }
  }

  &.ghost {
    color: #ff8b00 !important;
    background: transparent;
    border: 1px solid #ff8b00;

    &.disabled {
      background: transparent;
    }
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    border: 1px solid #dadada;
    color: #bfbfbf !important;
    background: transparent;
  }

  &.dark-mode {
    &.primary {
      &.disabled {
        background: #3a4856;
        color: #8a9aaa !important;
      }
    }

    &.secondary {
      color: #f0f0f0 !important;

      &.disabled {
        color: #8a9aaa !important;
      }
    }

    &.ghost {
      color: #ff8b00 !important;
      border-color: #ff8b00;

      &.disabled {
        color: #8a9aaa !important;
        border-color: #3a4856;
      }
    }

    &.disabled {
      border-color: #3a4856;
      color: #8a9aaa !important;
      background: transparent;
    }
  }

  &.large {
    height: 48px;
  }

  &.medium {
    height: 40px;
  }

  &.small {
    height: 32px;
  }

  .content {
    display: flex;
    font-weight: 600;

    i {
      margin-right: 10px;
      margin-left: 10px;
    }

    &.no-icon {
      margin-right: 10px;
    }
  }

  .spinner {
    font-size: 7px;
    border-left: 0.6em solid #fff;
    border-top: 0.6em solid rgba(255, 255, 255, 0.2);
    border-right: 0.6em solid rgba(255, 255, 255, 0.2);
    border-bottom: 0.6em solid rgba(255, 255, 255, 0.2);
    animation: spinner 1.1s infinite linear;

    &,
    &:after {
      border-radius: 50%;
      width: 3.5em;
      height: 3.5em;
    }

    &.disabled {
      border-left: 0.6em solid #333;
    }

    .dark-mode & {
      border-left-color: #8a9aaa;
    }
  }

  @keyframes spinner {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
